module.exports = __webpack_public_path__ + "static/media/Madfit_Website_04.bb876193.jpg";